import React from "react";
import ReportWorkspace from "./ReportWorkspace";

const ReportInvoiceFull = props => <ReportWorkspace type="full" {...props} />;

export default ReportInvoiceFull;
